import React, { useContext } from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate } from 'react-router-dom';
import { OpenSwal } from '../../Utils';
import { Avatar, Paper, Chip, Stack, Link, LinearProgress } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { url_api_int_profile_details } from '../../RoutesMap';
import { AuthContext } from '../../Context/AuthProvider';
import { apiWithAuth } from '../../Services/Axios/axios';



function HeaderWithTextPaper(props) {
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    return (
        <Paper sx={{ backgroundColor: 'white', px: 1, pb: 1, mt: 1.5 }} >
            <Typography variant='caption' color={appThemeColor} >{props.header}</Typography>
            <Typography variant='body1' color={appThemeColor}>{props.body}</Typography>
            {/* <Grid container  >
                <Grid xs={10}>
                    <Typography variant='body1' color={appThemeColor}>{props.body}</Typography>
                    
                </Grid>
                <Grid xs={2} justifyContent='end' display='flex'>  <EditOutlinedIcon /> </Grid>
            </Grid> */}

        </Paper>

    )
}
function HeaderWithMultipleSelectPaper(props) {
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;


    return (
        <Box>
            {(props.option_list) && (props.option_list.length > 0) &&
                <Paper sx={{ backgroundColor: 'white', px: 1, pb: 1, mt: 1.5 }} >
                    <Typography variant='caption' color={appThemeColor} >{props.header}</Typography>
                    <Stack direction="row" spacing={1} useFlexGap flexWrap='wrap'>
                        {props.option_list.map((data, index) => {

                            return (<Chip key={index} label={data.label} sx={{ backgroundColor: props.list_color, color: '#fff' }} size='small' />)
                        })}



                    </Stack>
                    {/* <Grid container>
                        <Grid xs={10}>

                            <Box>

                            <Autocomplete
                        options={props.option_list}
                        isOptionEqualToValue={(option, value) => option.label === value.label}
                        getOptionLabel={(option) => option.label}
                        multiple
                        color={appThemeSecondaryColor}
                        ChipProps={{ color: appThemeSecondaryColor,onDelete:undefined }}
                        noOptionsText={'No ' + props.header + ' found'}
                        renderInput={(params) => <TextField {...params} color={appThemeSecondaryColor} fullWidth size='small' />}
                    />
                            </Box>
                           

                        </Grid>
                        <Grid xs={2} justifyContent='end' display='flex'>  <EditOutlinedIcon /> </Grid>
                    </Grid> */}

                </Paper>
            }

        </Box>

    )
}
function HeaderWithMultipleLogoPaper(props) {
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    return (
        <Box>
            {(props.option_list) && (props.option_list.length > 0) &&
                <Paper sx={{ backgroundColor: 'white', px: 1, pb: 1, mt: 1.5 }} >
                    <Typography variant='caption' color={appThemeColor} >{props.header}</Typography>
                    <Box>
                        <Stack direction="row" spacing={1} useFlexGap flexWrap='wrap'>
                            {props.option_list.map((data, index) => {
                                return (
                                    <Link key={index} href={data.link} target='_blank'><Avatar alt='logo' src={data.icon} variant='square' /></Link>)
                            })}
                        </Stack>
                    </Box>
                </Paper>
            }
        </Box>

    )
}



function RequestToUpdateProfile() {
    const { currentUser } = useContext(AuthContext);
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;



    const navigate = useNavigate();


    let iti_user_full_name = currentUser['custom:first_name'] + ' ' + currentUser['custom:last_name'];


    const [TabValue, setTabValue] = useState('1');
    const [ProfileDetails, setProfileDetails] = useState([]);
    const [ProfileDetailsLoadingStatus, setProfileDetailsLoadingStatus] = useState(false);


    const GoBackSetting = () => {
        navigate('/Interpreter/App_Setting');
    }

    useEffect(() => {
        apiWithAuth.post(url_api_int_profile_details, {}, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                setProfileDetails(response.data.data);
                setProfileDetailsLoadingStatus(true);
            } else if (response.data.status === false && response.data.message === "Token Expired") {
                //   setTimeZoneUpdateButtonLoadingStatus(false);
                OpenSwal('Token_error', navigate);
            } else {
                //   setTimeZoneUpdateButtonLoadingStatus(false);
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            // setTimeZoneUpdateButtonLoadingStatus(false);
            OpenSwal('Axios_error', response.message);
        });



    }, [])

    return (
        <Box >
            <Box>
                <Grid container >
                    <Grid xs={10} sm={10} md={10}> <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }} >View Interpreter Profile</Typography> </Grid>
                    <Grid xs={2} sm={2} md={2}>
                        <Box sx={{ display: 'flex', justifyContent: 'right', mt: -1 }}> <Button startIcon={<ArrowBackIcon sx={{ mr: -1, fontSize: '2px' }} />} onClick={GoBackSetting} sx={{ textDecoration: 'underline', textTransform: 'none', color: appThemeColor }} >Back</Button> </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box>



                <Box sx={{ mt: 2, mb: 10 }} >



                    {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Avatar alt={iti_user_full_name} src={decryptData(sessionStorage.getItem('iti_user_profile_img'))} sx={{ width: 90, height: 90, border: 2, borderColor: appThemeColor }} />
                    </Box> */}
                    <Box mt={1}>
                        <Typography variant="h5" align="center" fontWeight='bold' color={appThemeColor}>{iti_user_full_name}</Typography>

                        <Typography variant="subtitle1" align="center" color={appThemeColor}>Interpreter</Typography>

                    </Box>

                    <Box mt={1}>



                        <TabContext value={TabValue}  >
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={(e, newValue) => setTabValue(newValue)} textColor={appThemeSecondaryColor} indicatorColor={appThemeSecondaryColor} TabIndicatorProps={{ sx: { height: 3 } }} variant="fullWidth" >
                                    <Tab value="1" label="Professional Info" sx={{ textTransform: 'none', fontSize: 15 }} />
                                    <Tab value="2" label="Personal Info" sx={{ textTransform: 'none', fontSize: 15 }} />
                                </TabList>
                            </Box>

                            <TabPanel value="1" sx={{ padding: 0 }}>
                                {!ProfileDetailsLoadingStatus ? <Box display='flex' justifyContent='center' mt={10} > <LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%' }} /> </Box> :
                                    <Box>
                                        {(ProfileDetails.user_primary_language) && <HeaderWithTextPaper header='Primary Language' body={ProfileDetails.user_primary_language.label} />}
                                        <HeaderWithMultipleSelectPaper header='Additional Language' list_color='#009F96' option_list={ProfileDetails.user_additional_language_list} />
                                        <HeaderWithMultipleSelectPaper header='Field of Expertise' list_color='#F0AD4E' option_list={ProfileDetails.user_industry_list} />
                                        <HeaderWithMultipleSelectPaper header='Service Type' list_color='#CC1D1D' option_list={ProfileDetails.user_service_type} />
                                        <HeaderWithMultipleSelectPaper header='Mode' list_color='#CC1D1D' option_list={ProfileDetails.user_service_mode} />

                                    </Box>}

                            </TabPanel>
                            <TabPanel value="2" sx={{ padding: 0 }}>
                                {!ProfileDetailsLoadingStatus ? <Box display='flex' justifyContent='center' mt={10} > <LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%' }} /> </Box> :
                                    <Box>

                                        <HeaderWithTextPaper header='Email ID' body={ProfileDetails.user_email} />
                                        <HeaderWithTextPaper header='Phone Number' body={ProfileDetails.user_mobileno} />
                                        <HeaderWithTextPaper header='Address for Communication' body={ProfileDetails.user_address} />
                                        <HeaderWithMultipleLogoPaper header='Social Connects' option_list={ProfileDetails.user_social_links} />
                                    </Box>}

                            </TabPanel>

                        </TabContext>


                    </Box>


                </Box>
            </Box>




        </Box>
    );
}

export default RequestToUpdateProfile